// Note: This file is only used on the backend
// Frontend doesn't need Joi validation schemas

/**
 * Validation schema for KB Search parameters
 * Only available on backend where Joi is installed
 */
export const kbSearchSchema = null; // Placeholder for frontend compatibility

// Backend-only schema initialization
// This will be replaced/overridden on the backend where Joi is available
